import {useState} from "react";
import {UserEmergencyContact, UserInsurancePolicy, UserPassport} from "../../../types/user-data-types";
import {UserActivationGetType} from "../types";
import moment from "moment";

export type UserFields = {
    email: string;
    setEmail: (email: string) => void;
    phone: string;
    setPhone: (phone: string) => void;
    firstName: string;
    setFirstName: (firstName: string) => void;
    middleName: string;
    setMiddleName: (middleName: string) => void;
    lastName: string;
    setLastName: (lastName: string) => void;
    dateOfBirth: string;
    setDateOfBirth: (dateOfBirth: string) => void;
    gender: string | undefined;
    setGender: (gender: string | undefined) => void;
    genderAtBirth: string | undefined;
    setGenderAtBirth: (genderAtBirth: string | undefined) => void;
    mainLanguage: string | undefined;
    setMainLanguage: (language: string  | undefined) => void;
    secondaryLanguages: string[]
    setSecondaryLanguages: (languages: string[]) => void;
    nationality: string | undefined;
    setNationality: (nationality: string  | undefined) => void;
    countryISO: string | undefined;
    setCountryISO: (countryISO: string | undefined) => void;
    passports: UserPassport[];
    setPassports: (passports: UserPassport[]) => void;
    emergencyContacts: UserEmergencyContact[];
    setEmergencyContacts: (emergencyContacts: UserEmergencyContact[]) => void;
    insurancePolicies: UserInsurancePolicy[];
    setInsurancePolicies: (insurancePolicies: UserInsurancePolicy[]) => void;

    personalMobilePhone: string;
    setPersonalMobilePhone: (v: string) => void;
    homePhone: string;
    setHomePhone: (v: string) => void;
    personalEmail: string;
    setPersonalEmail: (v: string) => void;
};

export const useUserState = (): UserFields => {
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [firstName, setFirstName] = useState("");
    const [middleName, setMiddleName] = useState("");
    const [lastName, setLastName] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState("");
    const [gender, setGender] = useState<string | undefined>("");
    const [genderAtBirth, setGenderAtBirth] = useState<string | undefined>("");

    const [mainLanguage, setMainLanguage] = useState<string>()
    const [secondaryLanguages, setSecondaryLanguages] = useState<string[]>([])
    const [nationality, setNationality] = useState<string>()
    const [countryISO, setCountryISO] = useState<string>()

    const [passports, setPassports] = useState<UserPassport[]>([]);
    const [emergencyContacts, setEmergencyContacts] = useState<UserEmergencyContact[]>([]);

    const [personalMobilePhone, setPersonalMobilePhone] = useState("")
    const [homePhone, setHomePhone] = useState("")
    const [personalEmail, setPersonalEmail] = useState("")
    const [insurancePolicies, setInsurancePolicies] = useState<UserInsurancePolicy[]>([]);


    return {
        email, setEmail,
        phone, setPhone,
        firstName, setFirstName,
        middleName, setMiddleName,
        lastName, setLastName,
        dateOfBirth, setDateOfBirth,
        gender, setGender,
        genderAtBirth, setGenderAtBirth,
        mainLanguage, setMainLanguage,
        secondaryLanguages, setSecondaryLanguages,
        nationality, setNationality,
        countryISO, setCountryISO,
        passports, setPassports,
        emergencyContacts, setEmergencyContacts,
        personalMobilePhone, setPersonalMobilePhone,
        homePhone, setHomePhone,
        personalEmail, setPersonalEmail,
        insurancePolicies, setInsurancePolicies
    };
};

export const setUserFields = (data: UserActivationGetType, userState: UserFields) => {
    userState.setEmail(data.user.email)
    userState.setFirstName(data.user.profile.firstName);
    userState.setMiddleName(data.user.profile.middleNames);
    userState.setLastName(data.user.profile.lastName);
    userState.setDateOfBirth(moment.tz(data.user.profile.dateOfBirth, "UTC").format("YYYY-MM-DD"));
    userState.setGender(data.user.profile.gender);
    userState.setGenderAtBirth(data.user.profile.genderAssignedAtBirth);

    userState.setMainLanguage(data.user.mainLanguage)
    userState.setSecondaryLanguages(data.user.secondaryLanguages || [])
    userState.setNationality(data.user.profile.nationality)
    userState.setCountryISO(data.user.profile.countryOfResidence)

    userState.setEmergencyContacts(data.user.emergencyContacts)
    userState.setPassports(data.user.passports)

    userState.setPhone(data.user.mobilePhone?.e164 ?? "")
    userState.setPersonalMobilePhone(data.user.personalMobilePhone?.e164 ?? "")
    userState.setHomePhone(data.user.homePhone?.e164 ?? "")
    userState.setPersonalEmail(data.user.personalEmail ?? "")
}